module.exports = __webpack_public_path__ + "img/up_empty.d942cbbf.png";